<header>
  <div class="navbar navbar-dark bg-dark box-shadow">
    <div class="container-fluid d-flex justify-content-between">
      <a routerLink="/" class="navbar-brand d-flex align-items-center" *ngIf="authService.showlogin">
        <img src="assets/images/AF_MovProsAlarmas_Logo_RGB_NEG_2.svg" alt="" >
        {{ title }}
      </a>
      <a class="navbar-brand d-flex align-items-center" *ngIf="!authService.showlogin">
        <img src="assets/images/AF_MovProsAlarmas_Logo_RGB_NEG_2.svg" alt="" >
        {{ title }}
      </a>
      <div class="col-12 col-md-9" style="display: flex; justify-content: center;" *ngIf="isAuthenticated">
        <div class="col-12 col-md-12 d-flex flex-column align-items-center mt-2" style="max-width: 100%;">
          <div class="border-banner mb-2 text-center" style="color: rgb(252 201 0)">
            <mat-icon class="icon-banner" mat-list-icon>announcement</mat-icon>&nbsp;&nbsp;&nbsp;
            <strong>A partir del día 1 de julio de 2025, vamos a deshabilitar el acceso al Portal Partners a todos los usuarios inactivos que no accedan durante un período de 40 días. <br>
              En el caso de los representantes, el plazo será de 60 días para deshabilitar el acceso.
 </strong>
          </div>
        </div>
      </div>
      <nav *ngIf="!isAuthenticated" class="mr-md-3">
         <!-- <a class="p-2 text-light" routerLink="/register">Signup</a>  -->
         <!-- <a class="p-2 text-light" routerLink="/login">Login</a> -->

         <button mat-raised-button color="warn" (click)="login()" *ngIf="authService.showlogin"><i class="fas fa-sign-in-alt" aria-hidden="true"></i> Login</button>
      </nav>
      <nav *ngIf="isAuthenticated" class="mr-md-3">
        <div class="row">
          <div class="col" *ngIf="showPasswordExpiryWarning">
            <i
              *ngIf="passwordExpiryDays < 5"
              class="mat-icon"
              matTooltip="Su contraseña está a punto de caducar, por favor pinche aquí para cambiarla"
              matTooltipPosition="above"
              [matTooltipClass]="'password-expiry-tooltip'"
              (click)="redirectToChangePassword()"
              style="cursor: pointer; color: orange; font-size: 24px;">
              <mat-icon>warning</mat-icon>
            </i>
          </div>
          <div class="col text-right">
            <div><span class="text-light">{{name}}</span></div>
            <div><span class="text-light">{{role}}</span></div>
          </div>
          <div class="col">
            <a role="button">
            <i class="far fa-user-circle text-light" aria-hidden="true" (click)="signout()" title="Desconectar" ></i>
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
</header>
